import * as z from "zod/v4";

export const revertAutomationToOrigin = {
  name: "revertAutomationToOrigin" as const,
  input: z.object({ automationId: z.string() }),
  output: z.object({}),
};
